import React from "react";
import stemcafeLogo from "../assets/svg/stemcafe-logo.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";
import PricingDropdown from "./PricingDropdown";

const NavBar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleContactClick = (e: React.MouseEvent) => {
    e.preventDefault();
    //go to contact
    if (location.pathname === "/") {
      const contactElement = document.getElementById("contact");
      if (contactElement) {
        contactElement.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/#contact");
      setTimeout(() => {
        const contactElement = document.getElementById("contact");
        if (contactElement) {
          contactElement.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  };

  return (
    <header>
      <div className="container">
        <nav className="navbar navbar-light navbar-expand-lg">
          <Link className="navbar-brand" to="/">
            <img src={stemcafeLogo} alt="STEMCafe.io logo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarNavDropdown"
          >
            <ul className="navbar-nav">
              {/* <li className="nav-item"> */}
              {/*   <a className="nav-link" href="fr/index.html"> */}
              {/*     FR */}
              {/*   </a> */}
              {/* </li> */}
              <li className="nav-item">
                <Link className="nav-link" to="/about">
                  About
                </Link>
              </li>
              <PricingDropdown />
              <li className="nav-item">
                <Link className="nav-link" to="/gallery">
                  Gallery
                </Link>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#contact"
                  onClick={handleContactClick}
                >
                  Contact
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="https://jobkitten.com/apply/stem-cafe"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Careers
                </a>
              </li>
              <li className="nav-item nav-button">
                <a
                  className="nav-link"
                  href="https://stemcafe.typeform.com/to/jGdrkC"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Book a tour
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default NavBar;
